import React, { useEffect, useState } from "react";
import db from "../firebase";
import "../AlcoholSection.css"
import { useLocation, useNavigate } from "react-router-dom";

const AlcoholSection = ({baseName}) => {

  const [recommend, setRecommend] = useState([]);

  useEffect(() => {
    const recommendDrinks = () => {
      if(!baseName){
        return
      }
      db.collection("items")
        //変更をリアルタイムで監視するための関数
        .where("base", "==", baseName)
        .limit(2)
        .onSnapshot((snapshot) => {
          //引数のdocsにデータが格納されており、1つずつ取り出す
          setRecommend(
            snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }))
          );
        });    
    };
    recommendDrinks();
  }, []);

  const navigate = useNavigate();
  const handleCocktailSelect = (cocktail) => {
    navigate("/detail", {
      state: {
        id: cocktail.id,
      },
    });
  };
  


  return (
    <div className="kon">
      {recommend.map((item) => (
        <div  key={item.id}
        onClick={() => handleCocktailSelect(item)}
         className="conpo">
          
            <p>{item.name}</p><div className="aa">
            <img src={item.image} alt={item.name} />
            <p className="recipeStyle">{item.ingredients.map((ingredient)=>(<spam><li>{ingredient}</li></spam>))}</p></div>
        </div>
      ))}
    </div>
  );
};

export default AlcoholSection;
